import { BullpenStatusBase } from './base/bullpen-status-base';

export class BullpenStatus extends BullpenStatusBase { }